/**
 * The view style model.
 * 
 * @export
 * @class ViewStyle
 */
export class ViewStyle {

    /**
     * The style for background colors.
     *
     * @type {string}
     * @memberof ViewStyle
     */
    public backgroundColor?: string;

    /**
     * The style for colors.
     *
     * @type {string}
     * @memberof ViewStyle
     */
    public colors?: string;


    /**
     * Gets the default values.
     *
     * @static
     * @returns {ViewStyle}
     *
     * @memberof ViewStyle
     */
    public static default(): ViewStyle {
        return {
            backgroundColor: undefined,
            colors: 'wd-style-view-colors-1'
        };
    }

}